import React from "react";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Box,
  useTabsContext,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import CourseCategoryManagement from "./Tabs/coursesCategory";
import NoticeCategoryManagement from "./Tabs/noticesCategory";
import { PAGINATION_DEFAULTS, TAB_TYPES } from "@root/constants";
import { useNoticeTypeContext } from "@root/context/notice-type-context";
import { useCategoryContext } from "@root/context/admin-categories";

const TabIconLabel = ({ idx, label }: { idx: number; label: string }) => {
  const { selectedIndex } = useTabsContext();
  const isSelected = selectedIndex === idx;
  return (
    <Box display="flex" alignItems="center" gap={2} fontWeight="bold">
      {label}
    </Box>
  );
};

const CategoryTabs: React.FC = () => {
  const { t } = useTranslation("common");

  const tabData = [
    {
      label: t("categoryManagement.courseManagement"),
    },
    {
      label: t("categoryManagement.noticeManagement"),
    },
  ];
  const {
    fetchNoticeType,
    setSearch: setNoticeSearch,
    setPageNo: setNoticePageNo,
  } = useNoticeTypeContext();
  const {
    fetchCategories,
    setSearch: setCategorySearch,
    setPage: setCategoryPageNo,
  } = useCategoryContext();

  const handleTabChange = (index: number) => {
    if (index === TAB_TYPES.COURSES) {
      setCategorySearch("");
      setCategoryPageNo(1);
      fetchCategories({
        limit: PAGINATION_DEFAULTS.PAGESIZE,
        offset: (1 - 1) * PAGINATION_DEFAULTS.PAGESIZE,
      });
    }
    if (index === TAB_TYPES.NOTICES) {
      setNoticeSearch("");
      setNoticePageNo(1);
      fetchNoticeType({
        limit: PAGINATION_DEFAULTS.PAGESIZE,
        offset: (1 - 1) * PAGINATION_DEFAULTS.PAGESIZE,
      });
    }
  };

  return (
    <Box w="100%" maxW="full" overflowY={"auto"} mx="auto">
      <Tabs variant="unstyled" isFitted w="100%" onChange={handleTabChange}>
        <TabList
          mb={4}
          w="100%"
          background="linear-gradient(0deg, rgba(205, 214, 220, 0.32), rgba(205, 214, 220, 0.32))"
          h={"51px"}
          borderRadius="10px"
          p={1}
          display="flex"
          boxShadow="sm"
          overflowX="auto"
          whiteSpace="nowrap"
        >
          {tabData?.map((tab, idx) => (
            <Tab
              key={tab.label}
              fontWeight="600"
              fontSize="18px"
              color="gray.700"
              _selected={{
                color: "#1819B4",
                bg: "white",
                border: "0.5px solid #A7B2BA",
                boxShadow: "0px 1px 4px 0px #0000001F",
                borderRadius: "10px",
              }}
              _focus={{ boxShadow: "none" }}
              py={4}
              px={6}
              display="flex"
              alignItems="center"
              justifyContent="center"
              gap={2}
              textColor={"#2F2F34"}
              transition="all 0.2s"
              borderRadius="10px"
              minW="180px"
            >
              <TabIconLabel idx={idx} label={tab.label} />
            </Tab>
          ))}
        </TabList>
        <TabPanels>
          <TabPanel px={0}>
            <CourseCategoryManagement />
          </TabPanel>
          <TabPanel px={0}>
            <NoticeCategoryManagement />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default CategoryTabs;
